import axios from 'axios'
export default {
    getEvent(){
        return axios.get('/event')
            .then(response => {
                return response.data
            })
    },
    getEventDataSource(params){
        return axios.get('/event/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getEventDataSourceEventOrder(params){
        return axios.get('/event/datasource_eventorder', {params})
            .then(response => {
                return response.data
            })
    },
    getEventbyID(id,params){
        return axios.get('/event/' + id, {params})
            .then(response => {
                return response.data
            })
    }, 
    getEventbyID_withorder(id,params){
        return axios.get('/event/' + id +'/order', {params})
            .then(response => {
                return response.data
            })
    }, 
    getEventbyID_getorderdetail(id){
        return axios.get('/event/' + id +'/orderdetail')
            .then(response => {
                return response.data
            })
    },   
    getEventbyID_getorderdetail_bycode(id,code){
        return axios.get('/event-app/' + id + '/' + code +'/code')
            .then(response => {
                return response.data
            })
    }, 
    createEvent(formdata){
        return axios.post('/event', formdata,
        {
        headers: {
            'Content-Type': 'multipart/form-data'
        }})
            .then(response => {
                return response.data
            })
    },
    updateEvent(id,formdata){
        return axios.put('/event/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    updateEventDescription(id,formdata){
        return axios.put('/event/' + id + '/update_desc', formdata)
            .then(response => {
                return response.data
            })
    },

    publishEvent(id){
        return axios.get('/event/' + id + '/publish')
            .then(response => {
                return response.data
            })
    },
    getEventRegistrationPage(id){
        return axios.get('/event-registration/' + id)
            .then(response => {
                return response.data
            })
    },  
    createEventRegistration(id, formdata){
        return axios.post('/event-registration/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateEvent(id){
        return axios.put('/event/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateEvent(id){
        return axios.put('/event/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    cancelationEvent(id, formdata){
        return axios.put('/event/' + id + '/cancelation', formdata)
            .then(response => {
                return response.data
            })
    },
    setAsPaid(id){
        return axios.get('/eventorder/' + id + '/paymentsuccess')
            .then(response => {
                return response.data
            })
    },    
    createEventAttendance(id, formdata){
        return axios.post('/event/' + id + '/attendance', formdata)
            .then(response => {
                return response.data
            })
    },
    updateEventAttendance(id, formdata){
        return axios.post('/event/' + id + '/attendanceupdate', formdata)
            .then(response => {
                return response.data
            })
    },
    resendMailAttendance(id){
        return axios.get('/event/' + id + '/attendanceresendmail')
            .then(response => {
                return response.data
            })
    },
    updateBGImage(id,formData){
        return axios.post('/event/' + id + '/update_bgimage', formData)
            .then(response => {
                return response.data
            })
    },
    updateBannerImage(id,formData){
        return axios.post('/event/' + id + '/update_bannerimage', formData)
            .then(response => {
                return response.data
            })
    },
    getFormFieldData(id){
        return axios.get('/event-getformfield/' + id)
            .then(response => {
                return response.data
            })
    },
    cancelParticipant(id){
        return axios.get('/event/' + id + '/ordercancel')
            .then(response => {
                return response.data
            })
    },
}